import React from 'react';
import { useCustomPointStyles } from './CustomPoint.styles';

interface ICustomPointProps {
    label: string;
    name: string;
}

export const CustomPoint = ({ label, name }: ICustomPointProps) => {
    const classes = useCustomPointStyles();
    const imgPath = `${process.env.PUBLIC_URL}/assets/landing2020`;
    const srcTickIco = `${imgPath}/tick-icon.png`;
    return (
        <div className={classes.point} data-signa={`auth-custom-point-container${name}`}>
            <img className={classes.checkIcon} src={srcTickIco} alt="Check icon" />
            {label}
        </div>
    );
};
